import { useState } from "react";
import Collapsible from "../../genericComponents/Collapsible/Collapsible";

import "./JobCard.css";
import { jobStatusToString } from "../../../constants/Jobs";
import { formatDate } from "../../../utils/helpers";
import NfsButton from "../../genericComponents/NfsButton/NfsButton";
import StatusIcon from "../../../assets/jobs/status.svg?react";
import BriefcaseIcon from "../../../assets/jobs/briefcase.svg?react";
import type Graphic from "@arcgis/core/Graphic";

interface JobCardProps {
    jobObject: Graphic;
    onClick: () => void;
}

const JobCard: React.FC<JobCardProps> = ({ jobObject, onClick }) => {
    const [isOpen, setIsOpen] = useState(false);

    const getStatus = () => {
        const status = jobObject.attributes.status;
        return jobStatusToString(status);
    };

    return (
        <div className={`job-card-container ${isOpen ? "open" : ""}`}>
            <Collapsible
                isOpen={isOpen}
                setIsOpen={() => {
                    setIsOpen(!isOpen);
                }}
                title={jobObject.attributes.navn + (jobObject.attributes.sjomerke_nr ? " [" + jobObject.attributes.sjomerke_nr + "]" : "")}
                titleClassName="job-card-title"
                className="job-card-collapsible"
                icon={<BriefcaseIcon style={{ flex: "none" }} />}
                headerContent={
                    <div className="job-card-status-placement">
                        <div className="job-card-status-chip">
                            <StatusIcon />
                            <span>{getStatus()}</span>
                            <span style={{ width: "24px" }}></span>
                        </div>
                    </div>
                }
            >
                <div className="job-card-body">
                    <div className="flex-row space-between">
                        <span className="job-card-key">Sjømerke nummer</span>
                        <span className="job-card-value bold">{jobObject.attributes.sjomerke_nr}</span>
                    </div>
                    <div className="flex-row space-between">
                        <span className="job-card-key">Eier</span>
                        <span className="job-card-value bold">{jobObject.attributes.opprettet_av}</span>
                    </div>
                    <div className="flex-row space-between">
                        <span className="job-card-key">Opprettet</span>
                        <span className="job-card-value bold">{formatDate(jobObject.attributes.opprettet_dato)}</span>
                    </div>
                    <label className="job-card-key job-card-label">
                        Beskrivelse
                        <p className="job-card-value">{jobObject.attributes.beskrivelse}</p>
                    </label>
                    {/* <TextArea
                        label="Beskrivelse"
                        onChange={() => { }}
                        inputFieldId={jobObject.attributes.globalid}
                        value={jobObject.attributes.beskrivelse}
                        readonly
                    /> */}
                </div>
                <div className="job-card-footer">
                    <NfsButton onClick={onClick}>
                        <span className="job-card-button-text">Åpne</span>
                    </NfsButton>
                </div>
            </Collapsible>
        </div>
    );
};
export default JobCard;
